import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { FileExtension } from '../domain/enums/file-extension'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class ExportRefunds {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(fileExtension: FileExtension): Promise<string> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/exportRequestCreate/pt`,
      body: { data: { type: fileExtension, data: 'refunds', param: null } },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.result.id
    }

    throw new GeneralError()
  }
}
